import {
  Button,
  HStack,
  Stepper,
  Text,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { MeterType } from 'app/pages/request-single-page/request-single-page-slice';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { useResponsive } from 'app/hooks';
import { ResetReadingsButton } from './reset-readings-button';

type Props = {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  meterType: MeterType;
  lastValue: string | null;
  unit: string;
  estimated: number;
  error?: string;
};

export const MeterReadingInput = ({
  value,
  onChange,
  meterType,
  lastValue,
  unit,
  estimated,
  error,
}: Props) => {
  const theme = useV4Theme();
  const { viewport } = useResponsive();

  const lastValueNum = parseFloat(lastValue ?? '0');
  const hasValue = value !== undefined && !isNaN(value);
  const consumption = hasValue ? (value! - lastValueNum).toFixed(2) : '0.00';

  const textVariant = viewport.mobile ? 'body-14' : 'body-16';
  const isHeatMeter = meterType === 'HeatAreaMeter';

  return (
    <VStack spacing="s">
      <HStack spacing="xs">
        <Stepper
          min={0}
          max={isHeatMeter ? 99999.99 : 99999}
          allowDecimals={isHeatMeter}
          value={value}
          onChange={onChange}
          placeholder={lastValue ?? '0'}
          style={{
            flex: 1,
            border: error ? `1px solid ${theme.colors.red[500]}` : undefined,
            borderRadius: theme.radiuses.xs,
          }}
        />

        {!!(hasValue || estimated || viewport.desktop) && (
          <HStack
            flex={viewport.mobile ? 0 : 1}
            align="center"
            justify="flex-end"
            style={{ marginLeft: 8 }}
          >
            {hasValue ? (
              <ResetReadingsButton onClick={() => onChange(undefined)} />
            ) : estimated ? (
              <Button mode="neutral" onClick={() => onChange(estimated)}>
                {estimated}
              </Button>
            ) : null}
          </HStack>
        )}
      </HStack>

      {error ? (
        <Text variant={textVariant} color="red.500">
          {error}
        </Text>
      ) : (
        <HStack align="center" spacing="xxs">
          <Text variant={textVariant} color="gray.500">
            Текущий расход:
          </Text>
          <Text
            variant={textVariant}
            color={!hasValue ? 'gray.400' : undefined}
          >
            {consumption} {unit}
          </Text>
        </HStack>
      )}
    </VStack>
  );
};
